import {makeStyles} from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    breadCrumbs: {
        "& .MuiBreadcrumbs-separator": {
            fontSize: "x-large",
        }
    }
}));